module.exports = __webpack_public_path__ + "build/desktop/a/img/planet.216389fa679c3b2782cd8c23ddff4a86.svg";